import logErrors from '@nykaa/logger/logErrors';
import { ApiHelper } from 'shared/api';

import { queryStringFromParams } from 'shared/helpers/utils/url';
import { getDealsUrl } from 'shared/api/urls';
import { FetchHomePageParams } from './types';
import { transformWidgetsData } from './transformer';

// interface ProductParams {
//   id: string,
//   skuId?: string,
// }

const ERROR_FETCHING_HOME_PAGE_WIDGETS = 'Error fetching Home page widgets';
export const getHomePageWidgets = async (params: FetchHomePageParams, pagePrefix?: string, isPaginationEnabled?: boolean) => {
  const url = getDealsUrl();
  const queryParams = {
    ...params,
  };

  const queryString = queryStringFromParams(queryParams);

  try {
    const {
      data: { result },
    } = await ApiHelper(`${url}${queryString}`, 'get');

    const inventoryResult = isPaginationEnabled ? result.inventory_data : result;

    if (!inventoryResult) {
      throw new Error('"result" not found in home page widgets api -> data');
    }
    let modifiedResult = inventoryResult;

    if (params.page_data && Array.isArray(inventoryResult)) {
      modifiedResult = inventoryResult.map((inventory: {}) => ({ ...inventory, api_page_data: params.page_data }));
    }

    return {
      widgets: transformWidgetsData(modifiedResult, pagePrefix).widgets,
      remaining_inventories_ids: result.remaining_inventories_ids || [], // For pagination API V2 call
    };
  } catch (e) {
    logErrors(e, `${ERROR_FETCHING_HOME_PAGE_WIDGETS} :url=${url}`);
    throw e;
  }
};
